var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart-container",
      class: [
        _vm.expanded != true ? "unexpanded" : "",
        _vm.selectedProducts.length > 0 ? "hasProduct" : ""
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "expand-arrow",
          on: {
            click: function() {
              _vm.expanded = !_vm.expanded
            }
          }
        },
        [_c("span", [_vm._v(">")])]
      ),
      _vm._v(" "),
      _vm.expanded == true
        ? _c(
            "div",
            {
              staticClass: "unexpanded-cart",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              !_vm.redeem_without_full_capacity
                ? _c("div", { staticClass: "price-container" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.capacity) + "%")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "price" }, [_vm._v("Full")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.canCheckout
                ? _c("p", { staticClass: "products-container-title" }, [
                    _vm._v("You are good to go")
                  ])
                : _c(
                    "p",
                    { staticClass: "products-container-title" },
                    [
                      _vm._v(
                        "Add up to (" + _vm._s(_vm.maxProductsToAdd) + ") "
                      ),
                      _c("br"),
                      _vm._v(" more gifts! "),
                      _vm.redeem_without_full_capacity &&
                      _vm.minimumProductsToAdd > 0
                        ? [
                            _vm._v(
                              "Minimum gifts: " +
                                _vm._s(_vm.minimumProductsToAdd)
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "products-container no-scrollbar" },
                [
                  _vm._l(_vm.selectedProducts, function(addonProduct) {
                    return _c("li", { key: addonProduct.variants[0].id }, [
                      _c("div", { staticClass: "addon-container" }, [
                        _c("img", {
                          staticClass: "circle remove",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/x_blue.svg?v=1784232486",
                            alt: "x"
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeProduct(addonProduct)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "main-image",
                          attrs: {
                            loading: "lazy",
                            src: _vm.getProductImage(addonProduct)
                          },
                          on: {
                            click: function($event) {
                              return _vm.openProduct(addonProduct)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "circle qty" }, [
                          _vm._v(_vm._s(addonProduct.qty))
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.maxProductsToAdd, function(i) {
                    return _c("li", { key: "holder_" + i }, [_vm._m(0, true)])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "happybox-button border",
                  class: [
                    !_vm.canCheckout ? "gray" : "green",
                    _vm.isLoading ? "isLoading" : ""
                  ],
                  attrs: { disabled: !_vm.canCheckout },
                  on: { click: _vm.checkout }
                },
                [_vm._v(_vm._s(_vm.isLoading ? "loading..." : "Next Step"))]
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "addon-container placeholder" }, [
      _c("img", {
        staticClass: "main-image",
        attrs: {
          loading: "lazy",
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/add_gift.svg?v=1714663304"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }